import React from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import PrivateRoute from './PrivateRoute';
import EventsPage from './EventsPage';
import LoginPage from './LoginPage';
import RegistrationPage from './RegistrationPage';
import PasswordResetPage from './PasswordResetPage';
import EnterPasswordResetPage from './EnterPasswordResetPage';
import FuneralHomesPage from './FuneralHomesPage';
import FuneralHomeViewPage from './FuneralHomeViewPage';
import OnboardPage from './OnboardPage';
import Menu from './Menu';

import 'semantic-ui-css/semantic.min.css';
import configureStore from '../store/configureStore';

const store = configureStore();

const App = () => {
  return (
    <Provider store={store}>
      <HashRouter>
        <Menu />
        <Switch>
          <PrivateRoute exact path="/" component={() => <div style={{ padding: 50}}><h2>Welcome to Funeral Live Admin</h2></div>} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/register/:token" component={RegistrationPage} />
          <Route exact path="/resetPassword" component={PasswordResetPage} />
          <Route exact path="/resetPassword/:token" component={EnterPasswordResetPage} />
          <PrivateRoute exact path="/events" component={EventsPage} />
          <PrivateRoute exact path="/funeralhomes" component={FuneralHomesPage} />
          <PrivateRoute path="/funeralhomes/:id" component={FuneralHomeViewPage} />
          <PrivateRoute exact path="/onboard" component={OnboardPage} />
        </Switch>
      </HashRouter>
    </Provider>
  );
}

export default App;
